// Cascading filter scope on the time_entries page.
//
// The three Scope selects (Customer / Project / Task) are hierarchical:
// you can only pick a specific project if a customer is selected, and a
// specific task if a project is selected. When a parent select is reset
// to "All" (value 'A'), this controller forces its children to "All" too
// and disables them so the form clearly communicates what's pickable.
//
// Server-side rendering still scopes the option lists by the parent
// values (see _filtered_projects_options / _filtered_tasks_options), so
// after a submit the lists arrive correctly narrowed. This controller
// just keeps the UI honest in between submits.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["customer", "project", "task"]
  declare readonly customerTarget: HTMLSelectElement
  declare readonly projectTarget: HTMLSelectElement
  declare readonly taskTarget: HTMLSelectElement

  connect(): void {
    this.sync()
  }

  sync(): void {
    const cAll = this.isAll(this.customerTarget)
    if (cAll) this.resetToAll(this.projectTarget)
    this.setDisabled(this.projectTarget, cAll)

    const pAll = this.isAll(this.projectTarget)
    if (cAll || pAll) this.resetToAll(this.taskTarget)
    this.setDisabled(this.taskTarget, cAll || pAll)
  }

  private isAll(sel: HTMLSelectElement): boolean {
    return sel.value === "A" || sel.value === ""
  }

  private resetToAll(sel: HTMLSelectElement): void {
    // Prefer the 'A' sentinel if it exists; otherwise pick the first option
    // (which is the "All …" entry in our option partials).
    const hasA = Array.from(sel.options).some(o => o.value === "A")
    sel.value = hasA ? "A" : (sel.options[0]?.value ?? "")
  }

  private setDisabled(sel: HTMLSelectElement, disabled: boolean): void {
    sel.disabled = disabled
    sel.classList.toggle("opacity-50", disabled)
    sel.classList.toggle("cursor-not-allowed", disabled)
  }
}
